/**
 * @typedef {import('redux').Store} Store
 */

import rootReducer from './root_reducer';
import middlewares from './middlewares';
import { configureStore as rtkConfigureStore, createListenerMiddleware } from '@reduxjs/toolkit';
import { enableES5 } from 'immer';
import createSubscriber from './lib/createSubscriber';

enableES5();


export default function configureStore (pStoreOptions, pTransports) {
  const listenerMiddleware = createListenerMiddleware({
    extra: pTransports
  });

  const options = {
    devTools: {
      actionsDenylist: ['APP/SET TIME']
    },
		reducer: rootReducer,
		middleware: (getDefaultMiddleware) => {
      return getDefaultMiddleware(
        {
          immutableCheck: process.env.NODE_ENV === 'development',
          thunk: {
            extraArgument: pTransports
          },
          serializableCheck: process.env.NODE_ENV === 'development',
        })
        .prepend(listenerMiddleware.middleware)
        .concat(middlewares)
    },
		preloadedState: pStoreOptions?.preloadedState ?? {},
	};

	const store = rtkConfigureStore(options);
  /* TODO: avoid use at the same time provided listenerMiddleware and my custom subscriber/observer */
	store.observers = createSubscriber(store);

  store.listener = {
    startListening: listenerMiddleware.startListening,
    stopListening: listenerMiddleware.stopListening,
    clearListeners: listenerMiddleware.clearListeners,
  }

	return store;
}
